export default __webpack_public_path__ + "static/media/black_vector.dda06c61.svg";